<template>
  <div style="margin: 10px; border: 1px solid #eee; padding: 0 10px; border-radius: 5px">
    <div class="title">
      <strong>{{ form.storeName }}预估及实销数据分析（套）</strong>
    </div>
    <el-table border :data="tableData" v-if="form.storeId == 0 || radio == '年'" :row-class-name="rowClassFunc" v-loading="loading">
      <template v-for="item in columnData">
        <el-table-column :key="item.prop" :label="item.label" :prop="item.prop" v-if="item.label === '类型'">
          <template slot-scope="scope">
            <template>
              {{ scope.row[item.prop] }}
              <el-tooltip
                class="item"
                effect="dark"
                :content="tips"
                placement="top-start"
                v-if="
                  (scope.row.type == '有预有销产品实销量' ||
                    scope.row.type == '无预估外销量' ||
                    scope.row.type == '共超卖' ||
                    scope.row.type == '预估金额(万)' ||
                    scope.row.type == '实际达成率') &&
                  radio == '日'
                "
                :open-delay="500"
              >
                <span class="el-icon-warning-outline" @mouseover="tipsType(scope.row)"></span>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content="tips"
                placement="top-start"
                v-if="
                  (scope.row.type == '有预有销产品实销量' ||
                    scope.row.type == '无预估外销量' ||
                    scope.row.type == '实际预销达成率' ||
                    scope.row.type == '当前应达成率' ||
                    scope.row.type == '共超卖' ||
                    scope.row.type == '预估金额(万)' ||
                    scope.row.type == '实际达成率') &&
                  (radio == '月' || radio == '季度' || radio == '自定义')
                "
                :open-delay="500"
              >
                <span class="el-icon-warning-outline" @mouseover="tipsType(scope.row)"></span>
              </el-tooltip>
            </template>
          </template>
        </el-table-column>
        <el-table-column :key="item.prop" :label="item.label" :prop="item.prop" align="right" v-else-if="item.label === '全平台'"></el-table-column>
        <el-table-column :key="item.prop" :label="item.label" :prop="item.prop" align="right" v-else></el-table-column>
      </template>
    </el-table>
    <el-table :data="originData" border :cell-style="rowClass" v-else-if="form.storeId != 0 && radio != '日' && radio != '年'">
      <el-table-column label="预估总量" prop="estimateTotal"></el-table-column>
      <el-table-column label="月销售总量" prop="monthSaleTotal"></el-table-column>
      <el-table-column label="有预有销产品实销量" prop="preOrSaleTotal"></el-table-column>
      <!-- <el-table-column label="预估外销量" prop="preExportNum"></el-table-column> -->
      <el-table-column label="无预估外销量" prop="noPreSaleNum"></el-table-column>
      <el-table-column label="当前应达成率" prop="currentSalesFulfillmentRate"></el-table-column>
      <el-table-column label="实际预销达成率" prop="actPreSaleAttRate"></el-table-column>
      <el-table-column label="共积压" prop="backlogTotal"></el-table-column>
      <el-table-column label="积压率" prop="backlogRate"></el-table-column>
      <el-table-column label="共超卖" prop="oversoldTotal"></el-table-column>
      <el-table-column label="超卖率" prop="oversoldRate"></el-table-column>
      <el-table-column label="预估金额(万)" prop="estimatedAmount"></el-table-column>
    </el-table>
    <el-table :data="originData" border :cell-style="rowClass" v-else-if="form.storeId != 0 && this.radio == '日'">
      <el-table-column label="预估总量" prop="estimateTotal"></el-table-column>
      <el-table-column label="当前应售总量" prop="currentlyAvailableSale"></el-table-column>
      <el-table-column label="实际销量(总)" prop="actualSaleNum"></el-table-column>
      <el-table-column label="有预有销产品实销量" prop="preOrSaleTotal"></el-table-column>
      <el-table-column label="无预估外销量" prop="noSalesToSold"></el-table-column>
      <el-table-column label="实际达成率" prop="actualPreSaleRate"></el-table-column>
      <el-table-column label="共积压" prop="backlogTotal"></el-table-column>
      <el-table-column label="积压率" prop="backlogRate"></el-table-column>
      <el-table-column label="共超卖" prop="oversoldTotal"></el-table-column>
      <el-table-column label="超卖率" prop="oversoldRate"></el-table-column>
      <el-table-column label="预估金额(万)" prop="estimatedAmount"></el-table-column>
    </el-table>
    <div class="tips">说明：上述数据均为常规销售产品（不含新品、库存清理）预估及实销数据</div>
  </div>
</template>
<script>
import { debounce } from '@/utils/index';
export default {
  props: ['form', 'radio','months'],
  data() {
    return {
      columnData: [],
      originData: [],
      tableData: [],
      tips: '',
      loading: false
    };
  },
  //  computed: {
  //    tips() {
  //      let contentText = [

  //      ]
  //      return contentText
  //    }
  //  },
  mounted() {
    this.init();
  },
  methods: {
    tipsType(data) {
      if (data.type == '有预有销产品实销量') {
        this.$nextTick((_) => {
          if (this.radio == '日') {
            this.tips = '当前应售范围内的实销';
          } else {
            this.tips = '预估范围内的实销';
          }
        });
      } else if (data.type == '无预估外销量') {
        this.$nextTick((_) => {
          if (this.radio == '日') {
            this.tips = '应售 = 0，实销 > 0的产品销量合计';
          } else {
            this.tips = '预估调整 = 0，实销 > 0的产品实销合计';
          }
        });
      } else if (data.type == '当前应达成率') {
        this.$nextTick((_) => {
          this.tips = '截至当前应该达成的值 = 当前应售 / 预估总量';
        });
      } else if (data.type == '共超卖') {
        this.$nextTick((_) => {
          this.tips = '共超卖 = 实销总量 - 有预有销产品实销量';
        });
      } else if (data.type == '预估金额(万)') {
        this.$nextTick((_) => {
          this.tips = '预估金额 = SKU预估调整量*SKU  A类价';
        });
      } else if (data.type == '实际达成率' || data.type == '实际预销达成率') {
        this.$nextTick((_) => {
          if (this.radio == '日') {
            this.tips = '实际达成率 = 有预有销产品实销量 / 当前应售总量';
          } else {
            this.tips = '实际预销达成率 = 有预有销产品实销量 / 预估总量';
          }
        });
      }
    },
    init: debounce(function () {
      this.loading = true
      let data = {
        data: {
          planTime: this.form.planTime,
          storeId: this.form.storeId,
          type: this.radio == '日' ? 1 : this.radio == '月' ? 2 : this.radio == '年' ? 3 : this.radio == '季度' ? 4 : 5,
          months: this.months || ''
        },
      };
      this.$q.preSalePlan.getStoreAnalysisData(data).then((res) => {
        // console.log(this.radio);
        // let col1 = ['有预无销产品', '有销无预产品', '±30%内产品', '±30%外产品', '总产品'];
        let col1 = ['预估总量', '月销售总量', '有预有销产品实销量', '无预估外销量', '当前应达成率', '实际预销达成率', '共积压', '积压率', '共超卖', '超卖率','预估金额(万)'];
        if (this.radio == '日') {
          col1 = ['预估总量', '当前应售总量', '实际销量(总)', '有预有销产品实销量', '无预估外销量', '实际达成率', '共积压', '积压率', '共超卖', '超卖率','预估金额(万)'];
        }
        let data = res.data;
        this.originData = data;
        // console.log(data);
        // 设置表头
        let columnData = [];
        data.forEach((item, index) => {
          let obj = {
            label: item.storeName,
            prop: String(index),
          };
          columnData.push(obj);
        });
        // console.log(data);
        columnData.unshift({
          label: '类型',
          prop: 'type',
        });
        this.$nextTick((_) => {
          this.columnData = columnData;
        });
        // console.log(columnData);
        // 设置tableData
        let tableData = [];
        if (this.radio != '日') {
          for (let index = 0; index < 11; index++) {
            let obj = {};
            obj['type'] = col1[index];
            for (let k = 0; k < data.length; k++) {
              if (index == 0) {
                obj[String(k)] = data[k]['estimateTotal'];
              } else if (index == 1) {
                obj[String(k)] = data[k]['monthSaleTotal'];
              } else if (index == 2) {
                obj[String(k)] = data[k]['preOrSaleTotal'];
              } else if (index == 3) {
                obj[String(k)] = data[k]['noPreSaleNum'];
              } else if (index == 4) {
                obj[String(k)] = data[k]['currentSalesFulfillmentRate'];
              } else if (index == 5) {
                obj[String(k)] = data[k]['actPreSaleAttRate'];
              } else if (index == 6) {
                obj[String(k)] = data[k]['backlogTotal'];
              } else if (index == 7) {
                obj[String(k)] = data[k]['backlogRate'];
              } else if (index == 8) {
                obj[String(k)] = data[k]['oversoldTotal'];
              } else if (index == 9) {
                obj[String(k)] = data[k]['oversoldRate'];
              } else if (index == 10) {
                obj[String(k)] = data[k]['estimatedAmount'];
              }
            }
            tableData.push(obj);
          }
        } else {
          for (let index = 0; index < 11; index++) {
            let obj = {};
            obj['type'] = col1[index];
            // console.log(data.length);
            for (let k = 0; k < data.length; k++) {
              if (index == 0) {
                obj[String(k)] = data[k]['estimateTotal'];
              } else if (index == 1) {
                obj[String(k)] = data[k]['currentlyAvailableSale'];
              } else if (index == 2) {
                obj[String(k)] = data[k]['actualSaleNum'];
              } else if (index == 3) {
                obj[String(k)] = data[k]['preOrSaleTotal'];
              } else if (index == 4) {
                obj[String(k)] = data[k]['noSalesToSold'] || 0;
              } else if (index == 5) {
                obj[String(k)] = data[k]['actualPreSaleRate'];
              } else if (index == 6) {
                obj[String(k)] = data[k]['backlogTotal'];
              } else if (index == 7) {
                obj[String(k)] = data[k]['backlogRate'];
              } else if (index == 8) {
                obj[String(k)] = data[k]['oversoldTotal'];
              } else if (index == 9) {
                obj[String(k)] = data[k]['oversoldRate'];
              } else if (index == 10) {
                obj[String(k)] = data[k]['estimatedAmount'];
              }
            }
            tableData.push(obj);
          }
        }

        // console.log(tableData);
        this.tableData = tableData;
      }).finally(_=>{
        this.loading = false
      });
    }, 500),
    rowClassFunc({ row, rowIndex }) {
      if (row.type == '实际预销达成率' || row.type == '实际达成率' || row.type == '积压率' || row.type == '超卖率') {
        return 'high-light';
      }
    },
    rowClass(data) {
      if (data.column.label == '实际达成率' || data.column.label == '实际预销达成率' || data.column.label == '积压率' || data.column.label == '超卖率') {
        return 'color: #FF3300;';
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.title {
  font-size: 16px;
  color: #444;
  margin: 10px 0;
}

.tips {
  color: #777;
  margin: 10px 0;
}

>>>.high-light {
  td {
    color: #FF3300;
  }

  td:first-child {
    color: #606266;
  }
}
</style>
